import * as BABYLON from "babylonjs";
import 'babylonjs-loaders';

const Spots = {
  "08_Level" : {
    id: "Eighth",
    iframSpotName : "08_spot_1",
    normalSpotName: "08_spot2",
    normalSpotNameExtra: "08_spot003",
  },
  "05_Level" : {
    id: "Fifth",
    iframSpotName : "05_spot_1",
    normalSpotName: "05_spot_002",
  },
  "04_Level" : {
    id: "Fourth",
    iframSpotName : null,
    normalSpotName: "04_spot_1",
  },
  "00_Level" : {
    id: "ground",
    iframSpotName : "00_spot_1",
    normalSpotName: "00_spot_002",
  },
  "-01_Level" : {
    id: "lowerGround",
    iframSpotName : null,
    normalSpotName: "-01_Spot_01",
  },
  "Landscape" : {
    id: "exterior",
    iframSpotName : null,
    normalSpotName: "Landscape_spot_01",
    normalSpotNameExtra: "Landscape_spot_002",
  },
};

export default class LoaderManager {
  constructor(sceneManager) {
    this.game = sceneManager.game;
    this.scene = sceneManager.scene;
    this.mirror = sceneManager.mirror;
    this.shadowGenerator = sceneManager.shadowGenerator;
    this.sceneManager = sceneManager;
    this.assetManager = new BABYLON.AssetsManager(this.scene);
  }
  loadAvatar(onFinish) {
    const loaderManager = new BABYLON.AssetsManager(this.scene);
    let model_task = loaderManager.addMeshTask(
      "avatar_task",
      "",
      `./models/newModel/`,
      `OPL10.glb`
    );
    model_task.onSuccess = (task) => {
      let rootMesh = task.loadedMeshes.find((mesh) => mesh.name === "__root__");
      // rootMesh.scaling = new BABYLON.Vector3(.15, .15, -.15);
      this.sceneManager.currentAvatar = rootMesh;
      for (let i = 0; i < task.loadedTransformNodes.length; i++) {
        let node = task.loadedTransformNodes[i];
        if (Spots[node.name]) { //if floor has spots
          console.log("node.name", node.name)
          console.log("Spots[node.name]", Spots[node.name])

          if(Spots[node.name].iframSpotName) { //iframSpots
            const iframSpot = node.getChildMeshes().find((mesh)=> mesh.name === Spots[node.name].iframSpotName );
            console.log("iframSpot", iframSpot)
            iframSpot.isPickable = true;
            iframSpot.actionManager = new BABYLON.ActionManager(this.scene);
            iframSpot.actionManager.registerAction(
                new BABYLON.ExecuteCodeAction(
                    BABYLON.ActionManager.OnPickTrigger, (bjsevt) => {
                        this.sceneManager.onSpotClick( Spots[node.name].iframSpotName, "iframe");
                    }
                )
            )
          } 
          if (Spots[node.name].normalSpotName) { //normalSpots
            const normalSpot = node.getChildMeshes().find((mesh)=> mesh.name === Spots[node.name].normalSpotName );
            normalSpot.isPickable = true;
            normalSpot.actionManager = new BABYLON.ActionManager(this.scene);
            normalSpot.actionManager
            .registerAction(
                new BABYLON.ExecuteCodeAction(
                    BABYLON.ActionManager.OnPickTrigger, (bjsevt) => {
                        this.sceneManager.onSpotClick( Spots[node.name].normalSpotName, "normal");
                    }
                )
            )
          }
          if (Spots[node.name].normalSpotNameExtra) { //normalSpots
            const normalSpot = node.getChildMeshes().find((mesh)=> mesh.name === Spots[node.name].normalSpotNameExtra );
            normalSpot.isPickable = true;
            normalSpot.actionManager = new BABYLON.ActionManager(this.scene);
            normalSpot.actionManager
            .registerAction(
                new BABYLON.ExecuteCodeAction(
                    BABYLON.ActionManager.OnPickTrigger, (bjsevt) => {
                        this.sceneManager.onSpotClick( `${Spots[node.name].normalSpotNameExtra}`, "normal");
                    }
                )
            )
          }

        }
        console.log("mesh", node.name)
        if(node.name.includes("Level")){
          this.sceneManager.floors.push(node)
        }    
      }
      this.sceneManager.floors.sort((ele,ele2)=> {
        if (ele.name < ele2.name) {
          return -1;
        }
        if (ele.name > ele2.name) {
          return 1;
        }
        return 0;
      });    

      for (let j = 0; j < task.loadedMeshes.length; j++) {
        let mesh = task.loadedMeshes[j];
        // this.mirror.renderList.push(mesh);

        mesh.receiveShadows=true;
        this.shadowGenerator.getShadowMap().renderList.push(mesh);
        this.shadowGenerator.addShadowCaster(mesh);
      }
      // glass.albedoColor = new BABYLON.Color3(0.180,0.345,0.298)
      const glass = this.scene.getMaterialByName("Glass");
      // glass.albedoColor = new BABYLON.Color3(127/255,127/255,127/255, 1).toLinearSpace();
      glass.metallic = 0;
      glass.roughness = 0;

      const RBrick = this.scene.getMaterialByName("RBrick"); 
      RBrick.bumpTexture.level = 0.87;
      RBrick.albedoTexture.level = 1.32;

      const Floor = this.scene.getMaterialByName("Floor"); 
      Floor.metallic = 0.08;
      Floor.roughness = 0.09;
      Floor.directIntensity = 0.12;
      Floor.bumpTexture.level = 0.0;
      Floor.albedoTexture.level = 1.54;

      const Glass = this.scene.getMaterialByName("Glass"); 
      Glass.indexOfRefraction = 3;
      Glass.subSurface.isRefractionEnabled = true;
      Glass.subSurface.refractionIntensity = 0.7;
      Glass.subSurface.volumeIndexOfRefraction = 3.0;
      
    };

    loaderManager.onProgress = (
      remainingCount,
      totalCount,
      lastFinishedTask
    ) => {
      this.game.engine.loadingUIText =
        "loading Assets " +
        remainingCount +
        " out of " +
        totalCount +
        " items still need to be loaded.";
    };

    loaderManager.onFinish = (tasks) => {
      console.log("doneeeeeee");        
        this.sceneManager.assignScaleAnimation(
          this.sceneManager.currentAvatar,
          () => {
            onFinish();

           }
        );
    };
    // Start loading
    loaderManager.useDefaultLoadingScreen = false;
    loaderManager.load();
  }
}
